import React from 'react';
/** icon-reorder-down-l */
/** icon-reorder-down */
export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
        <path
            d="M1.801 6.286a.744.744 0 0 0-.466 1.039c.047.099 1.617 1.582 4.877 4.609 2.645 2.455 4.87 4.509 4.946 4.565.471.346 1.213.346 1.684 0 .076-.056 2.301-2.11 4.946-4.565 3.271-3.037 4.83-4.51 4.877-4.609a.78.78 0 0 0-.052-.738c-.23-.326-.694-.426-1.003-.216-.082.056-2.273 2.074-4.868 4.485-2.595 2.411-4.729 4.384-4.742 4.384-.013 0-2.147-1.973-4.742-4.384C4.663 8.445 2.477 6.431 2.4 6.38a.76.76 0 0 0-.599-.094"
            fillRule="evenodd"
            fill="#1A2B49"
        />
    </svg>
);
